import React, { forwardRef, useImperativeHandle } from "react";
import ReactDatePicker from "react-datepicker";
import { twMerge } from "tailwind-merge";
import { useMask } from "@react-input/mask";
import Input from "components/input";
import dayjs from "dayjs";
import { CalendarIcon } from "@heroicons/react/outline";

type PropType = {
  value?: string; // dd/MM/yyyy HH:mm:ss hoặc dd/MM/yyyy HH:mm
  onChange?: (val: string) => void;
  placeholder?: string;
  id?: string;
  label?: string;
  error?: any;
  className?: string;
  showSeconds?: boolean; // Tùy chọn định dạng có giây hay không
  [x: string]: any;
};

const CustomInput = forwardRef<HTMLInputElement, any>((props, ref) => {
  const { showSeconds = true } = props;

  const inputRef = useMask({
    mask: showSeconds ? "__/__/____ __:__:__" : "__/__/____ __:__",
    replacement: { _: /\d/ },
  });

  useImperativeHandle(ref, () => inputRef.current);

  return (
    <div className="relative w-full">
      <Input type="text" ref={inputRef} {...props} />
      <CalendarIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
    </div>
  );
});

CustomInput.displayName = "CustomInput";

const DateTimeFormatPicker = forwardRef<any, PropType>(
  (
    {
      value,
      onChange,
      placeholder,
      error,
      className,
      showSeconds = true,
      ...rest
    },
    ref
  ) => {
    const formatStr = showSeconds ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY HH:mm";
    const displayPlaceholder =
      placeholder ?? (showSeconds ? "dd/mm/yyyy HH:mm:ss" : "dd/mm/yyyy HH:mm");

    return (
      <ReactDatePicker
        preventOpenOnFocus={true}
        selected={value ? dayjs(value, formatStr).toDate() : null}
        // onChange={(date: Date) => {
        //   if (onChange && date) {
        //     const formatted = dayjs(date).format(formatStr);
        //     onChange(formatted);
        //   }
        // }}
        onChange={(date: Date | null) => {
          if (onChange) {
            if (date) {
              const formatted = dayjs(date).format(formatStr);
              onChange(formatted);
            } else {
              onChange(""); // hoặc null, tùy bạn muốn reset về gì
            }
          }
        }}
        wrapperClassName="w-full"
        className={twMerge(
          `input h-[46px] text-sm rounded-md px-2 py-1 border w-full ${
            error
              ? "border-red-600 focus:border-red-600"
              : "border-gray-300 focus:border-brand-500"
          }`,
          className
        )}
        placeholderText={displayPlaceholder}
        dateFormat={showSeconds ? "dd/MM/yyyy HH:mm:ss" : "dd/MM/yyyy HH:mm"}
        timeFormat={showSeconds ? "HH:mm:ss" : "HH:mm"}
        timeIntervals={1}
        ref={ref}
        showTimeSelect
        customInput={<CustomInput showSeconds={showSeconds} />}
        {...rest}
      />
    );
  }
);

DateTimeFormatPicker.displayName = "DateTimeFormatPicker";

export default DateTimeFormatPicker;
